import * as React from 'react';
import { StyledInformationalPage } from '../../common/static.styles';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { TranslatedPath } from '../../components/navigation/language-switcher/LanguageSwitcher.props';
import { DefaultLayout } from '../../layout/default/DefaultLayout';

// @todo
const seo = {
  description:
    'Warner Bros. Entertainment Inc. is een wereldleider op het gebied van entertainment en alle ' +
    'daaraan verwante bedrijfstakken en nieuwe vormen van media en platformen.',
};

const translatedPaths: TranslatedPath[] = [{ locale: 'fr-BE', path: '/fr/a-propos' }];

const title = 'De Organisatie';

// noinspection JSUnusedGlobalSymbols
export default () => (
  <DefaultLayout locale='nl-BE' seo={seo} translatedPaths={translatedPaths}>
    <HeadTitle title={title} />
    <StyledInformationalPage>
      <div className='content'>
        <article>
          <h1>{title}</h1>
          <p>
            <strong>Warner Bros. Entertainment Inc.</strong> is een wereldleider op het gebied van entertainment en alle
            daaraan verwante bedrijfstakken en nieuwe vormen van media en platformen. Als onderdeel van Time Warner,
            staat de Studio vooraan bij elke vorm van entertainment, van bioscoopfilms, televisie en home entertainment
            tot het wereldwijd uitbrengen van DVD en Blu-ray, digitale distributie, videogames, animatie, het in
            licentie beheren van producten en merken, en het uitzenden van content. DC Entertainment, het bedrijf achter
            iconische superhelden als Batman, Superman, Wonder Woman, The Flash en honderden andere, maakt ook deel uit
            van Warner Bros.
          </p>
          <p>
            Warner Bros. Studios is opgericht op 4 april 1923, door de broers Albert, Sam, Harry en Jack L. Warner. In
            1927 zette “The Jazz Singer”, de eerste speelfilm met geluid, de toon voor innovatie en invloed die synoniem
            zou worden voor de naam Warner Bros.
          </p>
          <p>
            Vanaf die eerste jaren heeft Warner Bros. Studios aan een indrukwekkende erfenis gebouwd, door het creëren
            van een veelzijdig entertainmentbedrijf van ongeëvenaarde diepte en breedte. De consistentie en successen
            zijn het resultaat van een stabiel management, langdurige creatieve relaties met vele grote sterren en
            producenten en een onvoorwaardelijk streven naar uitmuntendheid.
          </p>
          <p>
            Vandaag de dag bestaat de bibliotheek van Warner Bros., een van de meest prestigieuze en waardevolste ter
            wereld, uit meer dan 79.000 uur beeldmateriaal, waaronder 7500 speelfilms en 4500 televisieprogramma’s met
            tienduizenden afleveringen. De Studio beheert ook een van de meest succesvolle verzamelingen merken en
            franchises.
          </p>
        </article>
      </div>
    </StyledInformationalPage>
  </DefaultLayout>
);
